import { connect } from 'react-redux';

import VPS from '../../components/sider/vps';

export default connect()(VPS);



// WEBPACK FOOTER //
// ./containers/sider/vps.js